import React from 'react';
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaGithub,
  FaLinkedin,
  FaTwitter,
  FaReact,
  FaNodeJs,
  FaHtml5,
  FaCss3Alt,
  FaJsSquare,
  FaPython,
  FaGitAlt,
  FaDocker,
  FaLock,
} from 'react-icons/fa';
import { SiTypescript, SiExpress, SiWebpack, SiFastapi, SiSqlalchemy, SiNextdotjs, SiTailwindcss, SiPostgresql, SiRailway, SiVercel } from 'react-icons/si';

export const ClerkIcon = () => <FaLock />;

export const EnvelopeIcon = () => <FaEnvelope />;
export const PhoneIcon = () => <FaPhone />;
export const MarkerIcon = () => <FaMapMarkerAlt />;
export const GithubIcon = () => <FaGithub />;
export const LinkedinIcon = () => <FaLinkedin />;
export const TwitterIcon = () => <FaTwitter />;
export const ReactIcon = () => <FaReact />;
export const NodeJsIcon = () => <FaNodeJs />;
export const Html5Icon = () => <FaHtml5 />;
export const Css3AltIcon = () => <FaCss3Alt />;
export const JsSquareIcon = () => <FaJsSquare />;
export const PythonIcon = () => <FaPython />;
export const GitAltIcon = () => <FaGitAlt />;
export const DockerIcon = () => <FaDocker />;
export const TypescriptIcon = () => <SiTypescript />;
export const ExpressIcon = () => <SiExpress />;
export const WebpackIcon = () => <SiWebpack />;
export const FastApiIcon = () => <SiFastapi />;
export const SqlalchemyIcon = () => <SiSqlalchemy />;
export const NextjsIcon = () => <SiNextdotjs />;
export const TailwindcssIcon = () => <SiTailwindcss />;
export const PostgresqlIcon = () => <SiPostgresql />;
export const RailwayIcon = () => <SiRailway />;
export const VercelIcon = () => <SiVercel />;
